import { OssMetricCards } from "../common/OssMetricCards";

export const OssDashboardKpiBoard = ({ items }) => (
  <OssMetricCards columns={{ xs: 2, md: 5, lg: 5 }}
    items={items.map((item) => ({ ...item, tone: item.color, unit: "건" }))} />
);
